const Field = (props) => {
  const { component } = props;
  return component(props);
};

export default Field;
